export class DefaultLunch {

    public id: number;
    public txt: String;
    public status: number;
    public customer_id: number;

}

